import { axiosGet } from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants";

async function fetchSectionThirteenTwo({ setMedia, dispatch }) {
  try {
    var response = await axiosGet({
      endpoint: ApiConstants.GET_MEDIA,
    });
    const data = response.data;
    dispatch(setMedia(data));

    return;
  } catch (error) {
    console.log("error = ", error);
    if (!error?.response) {
      console.log("No Server Response.");
    } else if (error.response?.status === 404) {
      console.log("Page Not Found");
    } else if (
      error.response?.status === 400 ||
      error.response?.status === 401
    ) {
      console.log("User Credit Expired!!!\nPlease Login Again.");
    } else {
      console.log("Internal Server Error.");
    }
    return;
  }
}

export default fetchSectionThirteenTwo;
